module.exports = __webpack_public_path__ + "static/media/real.efd87a5c.jpg";